import {useSuspenseRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {pullRequestsOverviewRoute} from '../../../routes/overview-route'
import {useRouteQueryKey} from '@github-ui/react-core/future/use-route-query-key'

export function useOverviewRouteData() {
  const {data, ...rest} = useSuspenseRouteQuery(pullRequestsOverviewRoute, 'mainQuery')
  return {...data, ...rest}
}

export function useOverviewRouteQueryKey() {
  return useRouteQueryKey(pullRequestsOverviewRoute, 'mainQuery')
}
